import { PDFDocument } from 'pdf-lib';
import 'core-js/actual/array/flat-map';

const edgeOpenOrSave = (dataBase64, filename, saveOnly = false) => {
  // Required Microsoft Edge <= 44.18362.449.0
  const dataBase64Cleaned = dataBase64.replace(`${filename}|data:application/pdf;base64,`, '');
  const byteCharacters = atob(dataBase64Cleaned);
  let byteNumbers = new Array(byteCharacters.length);

  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  if (saveOnly) {
    // @ts-ignore
    window.navigator.msSaveBlob(blob, filename);
  } else {
    // @ts-ignore
    window.navigator.msSaveOrOpenBlob(blob, filename);
  }
};

const isEdgeBrowser = () => {
  // @ts-ignore
  return window.navigator && window.navigator.msSaveOrOpenBlob && window.navigator.msSaveBlob;
};

export const downloadPdfFile = async (dataBase64: string, fileName: string) => {
  try {
    if (isEdgeBrowser()) {
      edgeOpenOrSave(dataBase64, fileName, true);
    } else {
      const downloadLink = document.createElement('a');
      downloadLink.href = dataBase64;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  } catch (e) {
    console.error(e);
  }
};

export const viewPdfFile = async (dataBase64: string, fileName: string) => {
  try {
    if (isEdgeBrowser()) {
      edgeOpenOrSave(dataBase64, fileName);
    } else {
      let pdfWindow = window.open('about:blank', '_blank');
      if (!pdfWindow) return;
      pdfWindow.document.title = fileName;
      pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='" + dataBase64 + "'></iframe>",
      );
    }
  } catch (e) {
    console.error(e);
  }
};

export const mergePdfFiles = async (pdfArray: (string | ArrayBuffer | Uint8Array)[]) => {
  const pdfDocumentResult = await PDFDocument.create();
  return await Promise.all(pdfArray.flatMap((pdfBase64) => PDFDocument.load(pdfBase64)))
    .then((pdfDocuments) =>
      Promise.all(
        pdfDocuments.flatMap((pdfDocument) =>
          pdfDocumentResult.copyPages(pdfDocument, pdfDocument.getPageIndices()),
        ),
      ),
    )
    .then((pdfPages) =>
      pdfPages
        .flat()
        .reduce((pdfDocument, page) => {
          pdfDocument.addPage(page);
          return pdfDocument;
        }, pdfDocumentResult)
        .save(),
    );
};

export const mergeJpegFiles = async (imageArray: (string | ArrayBuffer | Uint8Array)[]) => {
  const pdfDocument = await PDFDocument.create();

  return await Promise.all(imageArray.map((imageBase64) => pdfDocument.embedJpg(imageBase64)))
    .then((jpgImages) =>
      Promise.all(
        jpgImages.map((img) => {
          const imgDims = img.scale(1);
          const page = pdfDocument.addPage();
          page.drawImage(img, {
            x: page.getWidth() / 2 - imgDims.width / 2,
            y: page.getHeight() / 2 - imgDims.height / 2 + 250,
            width: imgDims.width,
            height: imgDims.height,
          });
          return page;
        }),
      ),
    )
    .then(() => pdfDocument.save());
};
